import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import {Button, ButtonProps} from "antd";
import {FaDownload} from "react-icons/fa";
import {saveAs} from "file-saver";
import _compact from "lodash/compact";

import "./DownloadButton.scss";

export interface IDownloadButtonProps extends ButtonProps {
  url?: string; // file url
  filename?: string;
  text?: string;
}

async function downloadFile(url: string, filename: string): Promise<void> {
  const extension = url.split("/")?.pop()?.split(".")?.pop();
  const filenameWithExt = _compact([filename, extension]).join(".");
  // Chrome and Firefox only download files if they are from the same url origin (https://www.w3schools.com/TAGS/att_a_download.asp)
  // This library uses a work-around that simulates a link from a local object, i.e. it triggers a download of a file from a url
  saveAs(url, filenameWithExt);
}

@autobind
@observer
export default class DownloadButton extends React.Component<IDownloadButtonProps> {
  @observable isDownloading: boolean = false;

  async onClick(event: any) {
    const {url, filename, onClick} = this.props;
    onClick && onClick(event); // call onClick from props
    if (url) {
      this.setIsDownloading(true);
      await downloadFile(url, filename || "file");
      this.setIsDownloading(false);
    }
  }

  @action
  setIsDownloading(value: boolean) {
    this.isDownloading = value;
  }

  public render() {
    const {filename, text, url, onClick, ...buttonProps} = this.props;
    return (
      <Button
        className="DownloadButton"
        type="link"
        shape={text ? "default" : "circle"}
        size="small"
        onClick={this.onClick}
        loading={this.isDownloading}
        icon={<FaDownload />}
        {...buttonProps}
      >
        {text && <span className="download-btn-text">{text}</span>}
      </Button>
    );
  }
}
